import React, { FC, useContext, useCallback } from 'react'
import { ThemeContext } from 'styled-components'
import { SolidButton, Card } from 'react-components'

import RoundIcon from './round-icon'
import { HowItWorksStepTransport } from '@common/transports/deprecated-home-page-transport'
import {
    ButtonContainer,
    CardContentContainer,
    DescriptionContainer,
    TextContainer,
    TitleContainer,
} from './how-it-works-step-card-styles'
import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'

interface Props {
    step: HowItWorksStepTransport
    isLoggedIn: boolean
}

const HowItWorksStepCard: FC<Props> = ({
    step: { image, title, description, dashboardButton, registerButton },
    isLoggedIn,
}) => {
    const theme = useContext(ThemeContext)
    const button = isLoggedIn ? dashboardButton : registerButton

    const _handleButtonClick = useCallback(() => {
        if (button && button === registerButton && button.eventLabel) {
            AnalyticsService.trackClickEvent(homePageEventCategories.HOW_IT_WORKS_SECTION, button.eventLabel)
        }
    }, [button, registerButton])

    return (
        <Card
            backgroundColor={theme.colors.white}
            borderRadius={theme.typography.border.radius.small}
            shadowed
            boxShadow={`0 ${theme.spacing.xxxSmall} ${theme.spacing.small} 0 #00000026`}
        >
            <CardContentContainer>
                <RoundIcon image={image} backgroundColor={`${theme.colors.tfwRed}19`} radius="3.125rem" />
                <TextContainer>
                    <TitleContainer>{title}</TitleContainer>
                    <DescriptionContainer>{description}</DescriptionContainer>
                </TextContainer>
                {button && (
                    <ButtonContainer>
                        <SolidButton
                            href={button.url}
                            padding="0.625rem 0.59375rem 0.6875rem"
                            width={theme.layout.fill}
                            onClick={_handleButtonClick}
                        >
                            {button.text}
                        </SolidButton>
                    </ButtonContainer>
                )}
            </CardContentContainer>
        </Card>
    )
}

export default HowItWorksStepCard
